import moment from 'jalali-moment'
import React from 'react'
interface IItemProps {
    item: IAcceptedDemand
}
export default function DetailAcceeptedLoan({ item }: IItemProps) {
    return (
        <div className=" my-2 text-sm">
            <hr />
            <div className=" w-full flex justify-between my-2">
                <p>تاریخ ثبت درخواست</p>
                <p>
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                </p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>ساعت ثبت درخواست</p>
                <p>
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('HH:mm:ss')}
                </p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>مبلغ درخواستی</p>
                <p>{item.amount && item.amount.toLocaleString()} تومان</p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>توسط</p>
                <p>{item.acceptor ? item.acceptor.name : 'ثبت نشذه'}</p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>ساعت تخصیص درخواست</p>
                <p>
                    {moment
                        .from(item.acceptance_datetime, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('HH:mm:ss')}
                </p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>
                    توضیح مدیر : {item.tag ? item.tag : 'توضیحی ثبت نشده است'}{' '}
                </p>
            </div>
        </div>
    )
}
